import {
    PROCESS_START,
    PROCESS_SUCCESS,
    PROCESS_ERROR,
  } from './ProcessTypes';
  
  const INITIAL_STATE = {
    loading: false,
    error: false,
    data: [],
  };
  
  export default (state: any = INITIAL_STATE, action: any) => {
    switch (action.type) {
      case PROCESS_START:
        return { ...state, loading: true, error: null };
  
      case PROCESS_SUCCESS:
        return { ...state, data: action.payload, loading: false };
  
      case PROCESS_ERROR:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  